import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { SmartMediaProps } from './SmartMedia.types';

const SmartMedia: React.FC<SmartMediaProps> = ({
  src,
  alt,
  className,
  type = 'image',
  loop = true,
}) => {
  const [animationData, setAnimationData] = useState<unknown | null>(null);

  useEffect(() => {
    if (type === 'lottie' && src.endsWith('.json')) {
      fetch(src)
        .then((res) => res.json())
        .then(setAnimationData)
        .catch((err) => {
          console.error('Failed to load Lottie animation:', err);
          setAnimationData(null);
        });
    }
  }, [src, type]);

  if (type === 'lottie') {
    return (
      <div className={className}>
        {animationData ? (
          <Lottie animationData={animationData} loop={loop} autoplay />
        ) : (
          <img src={src.replace('.json', '.gif')} alt={alt} />
        )}
      </div>
    );
  }

  return (
    <img
      key={src}
      src={src}
      alt={alt}
      loading={type === 'gif' ? 'eager' : 'lazy'}
      className={className}
      style={{ display: 'block' }}
    />
  );
};

export default SmartMedia;
